import React from 'react';
import {connect} from 'react-redux';

// reactstrap components
import {
    Card,
    Container,
    Row,
    Table,
} from 'reactstrap';

const Plugin = (props) => {
    return (
        <>
            <Container fluid>
                <Row>
                    <div className='col'>
                        <Card className='shadow mt-6 mb-6'>
                            <div className='table-responsive mac-scrollbar'>
                                <Table className='align-items-center table-flush' style={{minHeight: 200}}>
                                    <thead>
                                        <tr>
                                            <th scope='col'>Version</th>
                                            <th scope='col'>Updated Date</th>
                                            <th scope='col'>Description</th>
                                            <th scope='col'>Download</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                2.8.1
                                            </td>
                                            <td>
                                                25-Apr-2025
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        Fix: Fix single custom size for loose sheet
                                                    </li>
                                                    <li>
                                                        Fix: Allow AI files to file uploads
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.8.1.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.7.2
                                            </td>
                                            <td>
                                                23-Dec-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        Fix: Custom size for loose sheet v2
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.7.2.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.7.1
                                            </td>
                                            <td>
                                                12-Oct-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        Fix: Dynamic price meta data display issue on cart
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.7.1.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.7.0
                                            </td>
                                            <td>
                                                08-July-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        New product: Loose sheet v2
                                                    </li>
                                                    <li>
                                                        New feature: Custom quantity
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.7.0.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.6.0
                                            </td>
                                            <td>
                                                30-June-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        New product: Booklet
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.6.0.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.5.2
                                            </td>
                                            <td>
                                                15-May-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        Optimize price calculations when invalid variants selected
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.5.2.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.5.1
                                            </td>
                                            <td>
                                                10-May-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        New Feature: Dynamic Price discount based on quantity of purchased item
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.5.1.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.4.0
                                            </td>
                                            <td>
                                                28-April-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        Added support for woocommerce-pdf-invoices-packing-slips plugin
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.4.0.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.3.0
                                            </td>
                                            <td>
                                                10-April-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        Optimize uploading documents when added product to cart
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.3.0.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.2.0
                                            </td>
                                            <td>
                                                01-April-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        Added additional error handling on wordpress for better detection
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.2.0.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.1.0
                                            </td>
                                            <td>
                                                21-March-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        Fixed dropdown optimization
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.1.0.zip'>Download</a>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                2.0.0
                                            </td>
                                            <td>
                                                01-March-2023
                                            </td>
                                            <td>
                                                <ul className='mb-0 pl-4'>
                                                    <li>
                                                        New Feature: Excart API integration
                                                    </li>
                                                </ul>
                                            </td>
                                            <td>
                                                <a href='https://admin.pricecal.net/plugin/priceGen-v2.0.0.zip'>Download</a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
};


const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(Plugin);